import type { CADJobStatusOptions } from '@partful/shared-types';
import { patchCADJob, PATCHCADJobResponse } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';

export interface UseUpdateCadRunInfoVars {
  runID: string;
  accountId: string;
  status: CADJobStatusOptions;
  errors?: Array<{ source: string; message: string }>;
}

export const useUpdateCadRunInfo = () =>
  useMutation<PATCHCADJobResponse, Error, UseUpdateCadRunInfoVars>(['updateCADJob'], {
    mutationFn: (variables) => {
      const { runID, accountId, status } = variables;

      return patchCADJob(runID, accountId, { status });
    },
  });
